export enum AdjuntoTableAction {
  ABRIR = 'AbrirAction',
  ELIMINAR = 'EliminarAction'
}
